// extracted by mini-css-extract-plugin
export default {"smoothFade":"Exercise_smoothFade__YMMt8","smoothShow":"Exercise_smoothShow__3mZAZ","syncContainer":"Exercise_syncContainer__a4GQm","score":"Exercise_score__7Hr7V"};